import { TreeNodeData } from './model';

export const TreeStore = new (class Store {
  queuedItem: TreeNodeData | null = null;
  processItem: PromiseWithResolvers<void> | null = null;

  update = (v: TreeNodeData) => {
    this.queuedItem = v;

    if (this.processItem) {
      // Queued item will be picked up in loop.
      return this.processItem;
    }

    this.processItem = Promise.withResolvers();
    this.updateCycle(this.processItem);

    return this.processItem;
  };

  private updateCycle = async (s: PromiseWithResolvers<void>) => {
    while (this.queuedItem) {
      try {
        const q = this.queuedItem;
        this.queuedItem = null;
        await this._writeToStore(q);
      } catch (ex) {
        s.reject(ex);
        this.processItem = null;
        return;
      }
    }

    s.resolve();
    this.processItem = null;
  };

  private _writeToStore = async (v: TreeNodeData) => {
    const root = await navigator.storage.getDirectory();
    const et = await root.getFileHandle('tree.json', { create: true });
    const fs = await et.createWritable();

    const textEncoder = new TextEncoder();
    const bytes = textEncoder.encode(JSON.stringify(v));
    await fs.write(bytes);
    await fs.close();
  };

  retreive = async (): Promise<TreeNodeData | null> => {
    const root = await navigator.storage.getDirectory();
    try {
      const et = await root.getFileHandle('tree.json', { create: false });
      const fs = await et.getFile();
      const textDecoder = new TextDecoder();
      const json = textDecoder.decode(await fs.arrayBuffer());
      return JSON.parse(json);
    } catch (ex) {
      if (ex instanceof DOMException && ex.name === 'NotFoundError') {
        return null;
      }

      throw ex;
    }
  };
})();
